document.addEventListener('DOMContentLoaded', () => {
  const popups = document.querySelectorAll('.product-detail-modal .popup');
  const modalOpenButtons = document.querySelectorAll('.product-detail-modal-open');

  function scrollLocker() {
    document.body.classList.add('scroll-lock');
  }

  function removeScrollLocker() {
    document.body.classList.remove('scroll-lock');
  }

  if (popups) {
    popups.forEach((popup) => {
      const closeButton = popup.querySelector('[data-popup-close]');

      closeButton.addEventListener('click', () => {
        popup.classList.remove('active');
        const overlay = document.querySelector('.product-detail__overlay');
        overlay.style.display = 'none';

        removeScrollLocker();
      });
    });
  }

  if (modalOpenButtons) {
    modalOpenButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.sectionId;
  
        const correspondingPopup = Array.from(popups).find((popup) => {
          return popup.dataset.id == id;
        });
  
        if (correspondingPopup) {
          correspondingPopup.classList.add('active');
          const overlay = document.querySelector('.product-detail__overlay');
          overlay.style.display = 'block';

          scrollLocker();
        }
      });
    });
  }

  const conventionalText = document.querySelectorAll('.product-detail-lead-in')[0];
  const uBandText = document.querySelectorAll('.product-detail-lead-in')[1];
  
  function toggleConventional() {
    const selectedValue = document.querySelector('input[name="Hip Lift Type"]:checked')?.value;
  
    if (selectedValue === 'U-Band') {
      conventionalText.style.display = 'none';
      uBandText.style.display = 'block';
    } else {
      uBandText.style.display = 'none';
      conventionalText.style.display = 'block';
    }
  }
  
  // Run on page load
  toggleConventional();
  
  // Listen for changes
  document.querySelectorAll('input[name="Hip Lift Type"]').forEach((radio) => {
    radio.addEventListener('change', toggleConventional);
  });  
});